import Constants from "expo-constants";
import * as Linking from "expo-linking";
import { useLocalSearchParams } from "expo-router";
import type { Platform } from "react-native";

export function useMagicLinkTokens() {
	const appScheme = Constants.expoConfig?.scheme;

	const {
		__clerk_status: statusParam,
		__clerk_created_session: sessionParam,
		mode,
		os: osParam,
		redeemCode: redeemCodeParam,
	} = useLocalSearchParams<{
		__clerk_status: string;
		__clerk_created_session: string;
		mode?: "signin" | "signup";
		os?: typeof Platform.OS;
		redeemCode?: string;
	}>();

	const url = Linking.useURL();

	let status = statusParam;
	let sessionId = sessionParam;
	let authMode = mode;
	let os = osParam;
	let redeemCode = redeemCodeParam;

	if (url) {
		const { queryParams } = Linking.parse(url);

		if (queryParams?.__clerk_status) {
			status = queryParams.__clerk_status as string;
		}
		if (queryParams?.__clerk_created_session) {
			sessionId = queryParams.__clerk_created_session as string;
		}
		if (queryParams?.mode) {
			authMode = queryParams.mode as "signin" | "signup";
		}
		if (queryParams?.os) {
			os = queryParams.os as typeof Platform.OS;
		}
		if (queryParams?.redeemCode) {
			redeemCode = queryParams.redeemCode as string;
		}
	}

	const deepLinkUrl =
		appScheme && sessionId && status && authMode && os
			? `${appScheme}://verify?__clerk_created_session=${sessionId}&__clerk_status=${status}&mode=${authMode}&os=${os}`
			: null;

	return { status, sessionId, deepLinkUrl, authMode, os, redeemCode };
}
